<script>
import ComponentAside from "./views/aside.vue";
import ComponentMenu from "./views/menu.vue";
import ComponentMain from "./views/main.vue";

export default {
  components: {
    ComponentAside,
    ComponentMain,
    ComponentMenu,
  },
};
</script>

<template>
  <div class="wrapper">
    <input style="display: none" id="toggle" type="checkbox" />
    <Component-menu></Component-menu>
    <Component-aside></Component-aside>
    <Component-main></Component-main>
  </div>
</template>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
}

html,
body,
#app,
.wrapper {
  height: 100vh;
}
body {
  box-sizing: border-box;
  // background-color: #f4f3ef;
  background: #E3E9EE;
  overflow: hidden;
}
a {
  text-decoration: none;
}
.material-icons {
  padding-right: 10px;
  cursor: pointer;
}
/* select option */
.select-div-ChartPlaylist {
  display: flex;
  align-items: baseline;
  justify-content: space-around;
}
.select-div-ChartPlaylist > select {
  width: 85%;
}

/* menu 的父層是 wrapper */
.menu {
  /* display: none; */
  position: absolute;
  right: 15px;
  top: 12px;
  font-size: 32px;
  z-index: 4;
}
.menu > .material-icons {
  cursor: pointer;
}

/* sidebar */
.sidebar {
  display: inline-block;
  width: 240px;
  height: 100%;
  max-height: 100%;
  background-color: #66615b;
  color: white;
  overflow: auto;
  position: relative;
  /* background */
  background-image: url(https://demos.creative-tim.com/vue-material-dashboard/img/sidebar-2.32103624.jpg);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-blend-mode: multiply;
  background-color: rgb(0 0 0 / 60%);
  transition: 0.5s;
}

/* sidebar > logo */
.logo {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 75px;
  position: relative;
}
.logo > a {
  color: white;
}

/* sidebar > profile */
.profile {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 0px 20px;
  margin: 20px 0px 40px;
}
.profile::after {
  content: "";
  position: absolute;
  bottom: -20px;
  background: #aaa;
  width: 80%;
  height: 1px;
}
.profile::before {
  content: "";
  position: absolute;
  top: -20px;
  background: #aaa;
  width: 80%;
  height: 1px;
}

/* sidebar > nav-left */
.nav-left {
  padding: 0px 20px;
}
.nav-left > div {
  margin: 20px 0px;
  line-height: 30px;
}
.nav-left a {
  color: white;
}

/* main */
.main {
  display: inline-block;
  width: calc(100% - 245px);
  height: 100vh;
  overflow: auto;
  position: relative;
}

/* main > navbar-top | header */
.navbar-top {
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: 75px;
  position: relative;
  z-index: 2;
  padding-left: 20px;
  font-size: 1.2rem;
  border-bottom: 1px solid #0000005e;
}
/* .navbar-top::before {
        content: "";
        position: absolute;
        bottom: 0px;
        background: rgb(212, 211, 211);
        width: 100%;
        height: 0.5px;
    } */

/* main > content */
.content {
  margin: 20px;
}

/* RWD */
/* > 768 (ipad) */
@media screen and (min-width: 769px) {
  #toggle:checked ~ .sidebar {
    width: 75px;
  }
  #toggle:checked ~ .sidebar .toggle-checked-hide-aside-text {
    display: none;
  }
  #toggle:checked ~ .main {
    width: calc(100% - 75px);
    transition: 0.5s;
  }
}

/* < 768 */
@media screen and (max-width: 768px) {
  /* 隱藏左側欄 */
  .sidebar {
    display: none;
  }
  /* display:none => inline-block */
  .menu {
    display: inline-block;
  }
  #toggle:checked ~ .sidebar {
    display: block;
    animation: slideIn 0.5s forwards;
    position: fixed;
    z-index: 3;
    width: 100%;
  }
  #toggle:checked ~ .menu .material-icons {
    color: white;
  }
  .navbar-top {
    background-color: #f3f0e6;
  }

  .navbar-top {
    position: fixed;
    width: 100%;
  }
  /* 加上 .navbar-top 的高度 往下推 75px */
  .content {
    margin-top: 75px;
    padding-top: 10px;
  }
  .main {
    width: 100%;
  }
  @keyframes slideIn {
    0% {
      transform: translateY(-100px);
    }
    100% {
      transform: translateY(0);
    }
  }
}

/* #toggle */
#toggle {
  display: none;
}
</style>
